
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 166.8 140.33"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"PRT"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M37.34 22.34h50.68v18.67H37.34zM0 22.34h28.01v6.67H0zM0 61.02h28.01v6.67H0zM0 99.69h28.01v6.67H0z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M73.52 129.03H9.84V0h101.69v81.45h-7V7H16.84v115.03h56.68v7z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M166.8 110.18a55.6 55.6 0 01-12 15q-17.09 15.1-42.4 15.11t-42.46-15.07a56.4 56.4 0 01-12.06-15 57.55 57.55 0 0112.06-15.15Q87.09 80 112.41 80t42.4 15.1a56.72 56.72 0 0111.99 15.08zm-34.34 0a18.74 18.74 0 00-5.9-13.9 19.59 19.59 0 00-14.22-5.78 20 20 0 00-8.34 1.78l-2.1-4.76q-23 3.95-33.7 22.66a43.14 43.14 0 007.49 9.71 48.48 48.48 0 0026 12.89A24.84 24.84 0 0191 123.7a23.84 23.84 0 01-4-13.52 24.86 24.86 0 011.59-8.76l5.03 1.58a19.19 19.19 0 00-1.4 7.17 18.73 18.73 0 005.9 13.93 20.46 20.46 0 0028.44 0 18.69 18.69 0 005.9-13.92zm-4.88 0a14.23 14.23 0 01-4.48 10.54 15.44 15.44 0 01-21.55 0 14.27 14.27 0 01-4.44-10.54 15 15 0 011-5.27l15.55 7-7.3-15.43a15.25 15.25 0 0116.79 3.11 14.25 14.25 0 014.43 10.59zm28.88 0a43.8 43.8 0 00-7.56-9.77 48.33 48.33 0 00-26.27-12.89 24.89 24.89 0 0110.91 9 24 24 0 014.19 13.71 23.7 23.7 0 01-4.09 13.52 25.11 25.11 0 01-10.76 9.08q22.98-3.99 33.58-22.65z"}})])])])
          )
        }
      }
    